import {Component, OnInit} from '@angular/core';
import {TranslocoPipe} from "@jsverse/transloco";
import {ActivatedRoute, RouterLink} from '@angular/router';
import {Service} from '../../../core/entities/service/service.entity';
import {ServiceService} from '../../services/service/service.service';
import {AppImageComponent} from '../../../core/components/image/image';
import {CurrencyPipe} from '@angular/common';
import {BookingService} from '../../services/booking/booking.service';

@Component({
  selector: 'app-booking-create-cancel',
  imports: [
    TranslocoPipe,
    RouterLink,
    AppImageComponent,
    CurrencyPipe
  ],
  templateUrl: './booking-create-cancel.component.html',
  styleUrl: './booking-create-cancel.component.scss'
})
export class BookingCreateCancelComponent implements OnInit {
  public photographerSlug: string|null = null;
  public serviceId: number|null = null;
  public bookingId: number|null = null;
  public service: Service|null = null;
  public billingInfo: BillingInfo|null = null;
  public customerEmail: string|null = null;

  public constructor(
    private readonly activatedRoute: ActivatedRoute,
    private readonly serviceService: ServiceService,
    private readonly bookingService: BookingService,
  ) {
  }

  public ngOnInit(): void {
    const slug = this.activatedRoute.snapshot.paramMap.get('slug');
    const service = this.activatedRoute.snapshot.paramMap.get('service');
    const bookingIdParam = this.activatedRoute.snapshot.paramMap.get('id');

    this.photographerSlug = slug;
    this.serviceId = service ? parseInt(service, 10) : null;
    this.bookingId = bookingIdParam ? parseInt(bookingIdParam, 10) : null;

    this.customerEmail = this.activatedRoute.snapshot.queryParamMap.get('email');
    const qpService = this.activatedRoute.snapshot.queryParamMap.get('service');
    if (!this.serviceId && qpService) {
      this.serviceId = parseInt(qpService, 10) || null;
    }

    if (this.serviceId) {
      this.loadService(this.serviceId);
    }
    this.tryLoadBillingInfos();
  }

  private loadService(serviceId: number): void {
    this.serviceService.getService(serviceId).subscribe({
      next: (srv) => this.service = srv,
      error: () => this.service = null
    });
  }

  private tryLoadBillingInfos(): void {
    if (!this.bookingId || !this.customerEmail) return;
    this.bookingService.getBillingInfos(this.bookingId, this.customerEmail).subscribe({
      next: (info) => this.billingInfo = info,
      error: () => this.billingInfo = null
    });
  }
}

interface BillingInfo {
  paymentDate: string|null;
  status: string;
  datetime: string;
  publicPrice: number;
  discount: number|null;
  depositAmount: number|null;
  invoiceUrl: string|null;
}
